{
    "11": {
        "type": "zone",
        "key": 11,
        "position": {
            "x": 18,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "14": {
        "type": "zone",
        "key": 14,
        "position": {
            "x": 19,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "19": {
        "type": "zone",
        "key": 19,
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "20": {
        "type": "zone",
        "key": 20,
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "22": {
        "type": "zone",
        "key": 22,
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "23": {
        "type": "zone",
        "key": 23,
        "position": {
            "x": 11,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "24": {
        "type": "zone",
        "key": 24,
        "position": {
            "x": 12,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "25": {
        "type": "zone",
        "key": 25,
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "level": 1
    },
    "26": {
        "type": "zone",
        "key": 26,
        "position": {
            "x": 12,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "31": {
        "type": "zone",
        "key": 31,
        "position": {
            "x": 10,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "32": {
        "type": "zone",
        "key": 32,
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "33": {
        "type": "zone",
        "key": 33,
        "position": {
            "x": 10,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "34": {
        "type": "zone",
        "key": 34,
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "35": {
        "type": "zone",
        "key": 35,
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "36": {
        "type": "zone",
        "key": 36,
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "37": {
        "type": "zone",
        "key": 37,
        "position": {
            "x": 4,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "40": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 40,
        "position": {
            "x": 16,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "43": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spearknight",
        "key": 43,
        "position": {
            "x": 13,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "49": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 49,
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "50": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 50,
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "51": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 51,
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "level": 1
    },
    "52": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 52,
        "position": {
            "x": 9,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "53": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 53,
        "position": {
            "x": 11,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "54": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 54,
        "position": {
            "x": 8,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "55": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 55,
        "position": {
            "x": 8,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "57": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 57,
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "59": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 59,
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "60": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 60,
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "61": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 61,
        "position": {
            "x": 4,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "62": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 62,
        "position": {
            "x": 3,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "64": {
        "affiliation": "bad",
        "bodyKey": "devil",
        "faceKey": "devil",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 64,
        "position": {
            "x": 6,
            "y": 11,
            "z": 1
        },
        "level": 1,
        "health": "30",
        "maxhealth": "30"
    },
    "65": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 65,
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "68": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "hammer",
        "name": "Beheader",
        "key": 68,
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "73": {
        "type": "zone",
        "key": 73,
        "position": {
            "x": 6,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "74": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Bladefiend",
        "key": 74,
        "position": {
            "x": 20,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "76": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Bladefiend",
        "key": 76,
        "position": {
            "x": 20,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "79": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "hammer",
        "name": "Beheader",
        "key": 79,
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "swordlord": {
        "key": "swordlord",
        "position": {
            "x": 13,
            "y": 3,
            "z": 1
        },
        "level": 1
    },
    "daggercloak": {
        "affiliation": "none",
        "key": "daggercloak",
        "position": {
            "x": 10,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "archdevil": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Gnash",
        "key": "archdevil",
        "position": {
            "x": 19,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "highpriest": {
        "affiliation": "none",
        "key": "highpriest",
        "position": {
            "x": 18,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "axeknight": {
        "affiliation": "none",
        "key": "axeknight",
        "position": {
            "x": 14,
            "y": 6,
            "z": 1
        },
        "level": 1
    }
}
